import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getTransactions = (
  {
    currentPage,
    pageSize,
    isLive,
    params = {}
  }
    : {
      currentPage: number,
      pageSize: number,
      isLive: boolean,
      params: Record<string, string | number | boolean>
    }
) => {
  const queryParams = {
    page: currentPage,
    page_size: pageSize,
    is_live: isLive,
    ...params
  };

  return axiosPrivate.get(`/dashboard/v1/transaction/listing`, { params: queryParams });
};